




































































import {Vue, Component} from 'vue-property-decorator'
import getConnection from "@/utils/signalr_connection";
import {formatDateTime} from "@/utils/formatters";

@Component({components: {}})
export default class Dashboard extends Vue {
  orders = [];
  columns;

  created() {
    this.columns = [
      {field: 'createdAt', title: this.$t('datum'), formatter: formatDateTime},
      {field: 'storeName', title: this.$t('objekat')},
      //{field: 'address', title: this.$t('adresa')},
      {field: 'createdBy', title: this.$t('kreator')},
    ];

    getConnection().on("newOrderCreated", this.getRecentOrders);
    this.getRecentOrders();
  }

  async getRecentOrders() {
    const { data } = await this.$http.get('/api/GetRecentOrders');
    this.orders = data;
  }

  destroyed() {
    getConnection().off("newOrderCreated", this.getRecentOrders);
  }
}
